let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iUIL3")).then(() => parcelRequire('aIz3E'));